import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images
import image from '../../images/gps-working/gps_image1.png'
import map1 from '../../images/gps-working/gps_map1.png'
import system from '../../images/gps-working/gps_satellitesys.png'
import gps_trileteration from '../../images/gps-working/gps_triliteration.png'

import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="GPS working and principles- GOOGLE MAPS|SKTUTS "
    description=" Ever wondered how google finds your location easily while your enemy can't.But how does Google does it.Stay tuned with us and find the answer."
    keywords="gps working,gps not working iphone,gps not working on iphone,gps on iphone not working,gps not working iphone 6,gps not working on iphone 6,gps not working,gps not working android,gps not working on android,gps not working on pokemon go,gps not working pokemon go,gps not working google maps,gps working without internet,iphone gps not working 2018,gps not working galaxy s6,gps working principle,gps stopped working on iphone,gps not working lg g5,gps not working on lg g5,gps not working on waze,gps isn't working on iphone 6,gps isn't working,gps not working waze,gps stopped working android,gps antenna working,garmin gps quit working,gps working video,sony xperia gps not working,gps system working principle,working gps joystick for pokemon go,gps not working galaxy s8,gps not working samsung s8,gps not working iphone 8,differential gps working principle,fake gps working with pokemon go,fly gps not working 2018,gps device working,gps modem working,gps module working,gps not working galaxy s7,gps not working iphone 7,gps not working note 5,gps not working oneplus 3t,gps not working oneplus 5,gps not working s7 edge,gps not working tomtom,gps not working without internet,gps receiver working,gps receiver working principle,gps sensor working,gps tracking device working,gps working frequency,gps working hours,gps working model,gps working pdf,gps working ppt,gps working principle and diagram,gps working principle pdf,gps working principle wiki,gps working process,working gps app for pokemon go,working gps for pokemon go,differential gps working principle pdf,endomondo gps not working xiaomi,fake gps not working 2018,fake gps not working 2019,fake gps not working july 2018,fake gps not working jurassic world alive,fake gps working 2018,fake gps working july 2018,gps chip working,gps clock working,gps clock working principle,gps coordinates working,gps isn't working on iphone,gps isn't working on pokemon go,gps isnt working on phone,gps jammer working,gps location working,gps map working,gps module working pdf,gps module working with arduino,gps neo 6m working,gps not working 11,gps not working 11.2.6,gps not working 2016 tahoe,gps not working 2018,gps not working 6s,gps not working after battery replacement,gps not working after screen replacement,gps not working after spoofing,gps not working after update,gps not working android 7.1.1,gps not working android 9,gps not working android auto,gps not working arma 3,gps not working asus zenfone,gps not working asus zenfone 2,gps not working asus zenfone 4,gps not working correctly,gps not working correctly on iphone,gps not working correctly on iphone 6,gps not working custom rom,gps not working dji spark,gps not working endomondo,gps not working fenix 3,gps not working fenix 5,gps not working fitbit,gps not working fitbit charge 2,gps not working fitbit ionic,gps not working for pokemon go,gps not working for waze,gps not working ford edge,gps not working ford explorer,gps not working ford focus,gps not working galaxy s9,gps not working garmin,gps not working garmin forerunner 235,gps not working gear s3,gps not working gmc yukon,gps not working google maps iphone,gps not working google pixel,gps not working honor 7x,gps not working honor 8,gps not working honor 9,gps not working htc m8,gps not working htc one m9,gps not working huawei,gps not working huawei p10,gps not working huawei p20,gps not working huawei p20 pro,gps not working in building,gps not working in dodge journey,gps not working in jeep,gps not working in jeep grand cherokee,gps not working in jeep wrangler,gps not working in vivo v9,gps not working in yukon,gps not working inside building,gps not working ios 11,gps not working ios 11.2.6,gps not working ios 11.3,gps not working ios 11.4,gps not working ios 12,gps not working ipad 4,gps not working iphone 10,gps not working iphone 5c,gps not working iphone 5s,gps not working iphone 6 2018,gps not working iphone 6 ios 12,gps not working iphone 6s ios 11,gps not working iphone 8 plus,gps not working iphone x,gps not working iphone xs max,gps not working j7,gps not working lenovo k6 power,gps not working lenovo tab,gps not working lg g4,gps not working lg g6,gps not working lg v20,gps not working lineage os,gps not working lyft,gps not working mi a1,gps not working miui 10,gps not working miui 9,gps not working moto e,gps not working nexus 5x,gps not working nexus 6p,gps not working nokia 5,gps not working nokia 6,gps not working nokia 7 plus,gps not working nokia 8,gps not working note 3,gps not working note 4,gps not working note 5 pro,gps not working note 8,gps not working note 9,gps not working on 3g,gps not working on 7 plus,gps not working on blackberry priv,gps not working on blackvue,gps not working on boat,gps not working on iphone x,gps not working on uconnect,gps not working on versa,gps not working on vivoactive,gps not working on zero off,gps not working oneplus 6,gps not working pixel 2,gps not working redmi 3s,gps not working redmi 4x,gps not working redmi note 3,gps not working redmi note 4,gps not working redmi note 5,gps not working redmi note 7,gps not working redmi note 7 pro,gps not working right,gps not working runkeeper,gps not working samsung 8,gps not working sync 3,gps not working t mobile,gps not working today,gps not working tomorrow,gps not working uber,gps not working verizon,gps not working vivo,gps not working vivoactive 3,gps not working vivoactive hr,gps not working vivosport,gps not working well on iphone,gps not working while driving,gps not working windows 10,gps not working with google maps,gps not working with pokemon go,gps not working xiaomi,gps not working xiaomi mi5,gps not working xiaomi miui 10,gps not working xiaomi note 4,gps not working xiaomi note 5,gps not working xperia,gps not working xperia z3,gps not working z3 compact,gps not working zenfone 4,gps quit working,gps quit working on iphone,gps stop working april 2019,gps stop working april 6,gps stopped working,gps stopped working iphone 7,gps stopped working lg g5,gps stopped working on iphone 6,gps system working diagram,gps technology working,gps working animation,gps working band,gps working diagram,gps working in a&e,gps working in car,gps working in hindi,gps working in tamil,gps working inside building,gps working mechanism,gps working mobile,gps working offline,gps working part time,gps working principle in hindi,gps working program,gps working properly,gps working quora,gps working system,gps working time,gps working tracker,gps working underground,gps working with diagram,iphone 6 gps quit working,iphone gps not working 2019,is gps working today,uk gps working in australia,uk gps working in canada,working dog gps tracker,working gps fake pokemon go,working gps faker for pokemon go,working gps hack for pokemon go,working gps joystick for pokemon go 2018,working gps spoof pokemon go,working gps spoof pokemon go android 2019,working gps.conf"
    />
    <header>
    <h1 className="header-h1">Working of GPS</h1>

    <div className="header-banner">
        <img src={image} alt="the working of GPS"/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
            <h1>An indepth guide on how does GPS works</h1>
                    <h2>Intro</h2>
                   <p>
                    Once upon a time, your ancestors used to look at the night sky to determine their location. Then we used a Thomas Guide, remember those? Today, it only takes one magical technology to get driving directions, send your picnic spot to a lost friend, or track how far you’ve gone during a workout. That technology is called GPS, and you’re about to find out the secret behind it. 
                   </p>
                   <h2>Starting</h2>
                   <p>
                     GPS stands for global positioning system and actually was build for military applications.Its first name was navstar and the first satellite for GPS was launched in Feb 22, 1978 and many others were launched suceeding it out of which some failed also.GPS became fully functional in the US by 1995 and the first GPS to used in the car was in 1996.The highest quality signals were used by the military till may 2000 after which it was made available to general public.<br/>Actaully it was designed for use only by the military purposes and not for civialians but an incident on Sept 1, 1983 made the US government to make it available to all countries.What happened was a Korean Airline flight 007 scheduled from New York to Seoul and taking a total of 269 peoples and due to non availability of the GPS it went into the prohibited air space of the Soviet Union and was ultimately shot down by the Soviet Union missiles.All the peoples died and after that the then president of United States gave a statement that it will be soon available to general public. 
                   </p>
                   <h2>Working</h2>
                   <p>
                     In any GPS unit there is a GPS reciever embedded which receives the signals sent from the GPS satellites.The satellites orbiting the earth after a definite time interval send signals to the GPS device.In that signal the current position of the satellite and the time of sending is there.
                     <br/>For the exact time measurements there are atomic clocks fitted into the satellites.These clocks are build such that it can show correct time for millions of years without any maintainence.When the signals are received by a GPS device it reads the message and then subtracts the time at which the satellite sends the data and the time the GPS device receives the data.
                     <br/>As a result of this the GPS device conforms it location with respect to that satellite.When a particular GPS device receives the signal from three differnet satellites, it can conform its location on the earth.
                    This process is called as 3D triliteration.
                   </p> 
                   <h3>Triliteration</h3>
                   <p>
                     <br/><img src={gps_trileteration} alt="the 3D trileteration process by which satellites detemrmine your position" />
                    <br/>To understand this term consider the above image.Consider you are at the red dot with a GPS device.Now when you switch on your device's GPS service then it gets a signal from satellite A confirming that it is in the range of satellite A but it maybe anywhere in that circle. After that it will get a signal from satellite B and also confirms that it is in range of satellite B also. So the common regions of the A and B are noted as you will be in the common region between the two satellites.After that it collects data from satellite C and when you are in the range of C also they will get your location.You might have known about the errors in the position due to GPS this is due to this phenomenon only.

                  </p>
                    <h2>Complications</h2>
                    <p>
                      <ul>
                        <li>As the GPS uses only 3 satellites for locating so the results produced may not be correct.<br/>
                          To solve this th GPS uses 4 satellites for this and thus the location is far more accurate.
                        </li>
                        <li>
                          The time move faster in places where there is less gravity.This is in accordance with the Einstien theory of relativity.Due to this the atomic clocks on the satellites are getting 38 microseconds faster than the actual timing on the earth.If nothing done GPS location will be off 6 miles everyday. <br/>
                          This also can be solved by using a fourth satellite.
                          <br/>
                          <img src={map1} alt="map of GPS"  />
                        </li>
                      </ul>
                    </p>
                    <h2>Facts</h2>
                    <p>
                      <ul>
                        <li>The satellites orbiting the earth for GPS are placed such that at all times each device can have access for atleast 4 satellites and its exact locations can be found out.
                          </li>
                        <li>The GPS used in our smartphones are of types AGPS which is Assisted Global Positioning System.This uses internet facility and assistant servers which helps in faster location detection.
                            When location services of the device are switched on the system first connects to the assistant GPS servers which have already collected the data of the satellites present in that area.<br/> Thus this helps in faster location detection.
                          </li>
                        <li>
                          <img src={system} alt="GPS services by other countries"  /><br/>
                          Except for GPS only Glonass is present which gives it service worldwide to everyone.This is operated by the Russia.Also there are other systems like Galileo ehich is operated by European Union and Beidou operated by the Chinese government.But these two are local services that means it does not provide worldwide services.</li>
                      <li>
                        India also has developed a navigation system called NAVIK which is used by the Indian army in the Indian subcontinent.This developed in response to the US not letting India use the GPS during the Kargil war and thus NAVIK was developed.
                      </li>
                        </ul>
                      <br/>
                      <p>To check out the most epic fails of google maps watch the video below</p>
                      <a href="https://www.youtube.com/embed/woHyQtKhP8c" target="_blank" rel="noopener noreferrer">SOURCE VIDEO</a>
                    </p>
            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

                
         
</section> 
</Layout>
)}

export default IndexPage
